import { render, staticRenderFns } from "./print-table-renwu.vue?vue&type=template&id=ed2d5c3a&scoped=true"
import script from "./print-table-renwu.vue?vue&type=script&lang=js"
export * from "./print-table-renwu.vue?vue&type=script&lang=js"
import style0 from "./print-table-renwu.vue?vue&type=style&index=0&id=ed2d5c3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2d5c3a",
  null
  
)

export default component.exports